// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkButton_root__I14SB","isActive":"MarkButton_isActive__3dvZH","icon":"MarkButton_icon__3V2H7"};